import { ComponentsModule } from '../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { UserTaskListPage } from './user-task-list';
import { UserTaskTemplateListModule } from "./user-task-template-list/user-task-template-list.module";

@NgModule({
  declarations: [UserTaskListPage],
  imports: [
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(UserTaskListPage),
    ComponentsModule,
    SuperTabsModule.forRoot(),
    UserTaskTemplateListModule,
  ],
})
export class UserTaskListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-list.module.ts